/** How the API files an upload: images as `image`, everything else as `document`. */
const toMediaKind = (file) => (String(file?.type || '').startsWith('image/') ? 'image' : 'document');

export default toMediaKind;
